function SMTPModal(node) {
  if (!this instanceof SMTPModal) return new SMTPModal();

  const that = this;

  /**
   * @type Element
   */
  this.node = node;

  this.loadJson = function (json) {
    this.json = json;

    const xhr = new XMLHttpRequest();
    const that = this;
    xhr.open("GET", "content/smtp-modal.html", true);
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) return;

      const smtpModal = that.node.querySelector(".smtp-modal");
      smtpModal.insertAdjacentHTML("beforeend", this.responseText);

      const emailsInput = smtpModal.querySelector("input[name=emails]");
      const subjectInput = smtpModal.querySelector("input[name=subject]");

      that.smtpInputs = {
        emailInput: emailsInput,
        subjectInput: subjectInput,
      };

      if (json.data.smtpConfig) {
        that.setValues(json.data.smtpConfig);
      }

      that.initHandlers(json);
    };
    xhr.send();
  };

  this.setValues = function (config) {
    if (config.emails) {
      this.smtpInputs.emailInput.value = config.emails;
    }
    if (config.subject) {
      this.smtpInputs.subjectInput.value = config.subject;
    }
  };

  this.initHandlers = function () {
    const smtpButton = this.node.querySelector(".smtp-button");

    smtpButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const closeButton = this.node.querySelector(".smtp-modal .close-button");
    closeButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const cancelButton = this.node.querySelector(".smtp-modal .cancel-button");
    cancelButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const saveButton = this.node.querySelector(".smtp-modal .save-button");
    saveButton.addEventListener("click", () => {
      this.saveConfig();
    });

    window.addEventListener("click", (event) => {
      this.windowOnClick(event);
    });
  };

  this.toggleModal = function () {
    const modal = this.node.querySelector(".smtp-modal");
    modal.classList.toggle("show-modal");
  };

  this.windowOnClick = function (event) {
    const modal = this.node.querySelector(".smtp-modal");
    if (event.target === modal) {
      this.toggleModal();
    }
  };

  this.saveConfig = function () {
    const smtpConfig = {
      emails: this.smtpInputs.emailInput.value
        ? this.smtpInputs.emailInput.value
        : null,
      subject: this.smtpInputs.subjectInput.value
        ? this.smtpInputs.subjectInput.value
        : null,
    };

    if (smtpConfig.emails) {
      const smptValidation = smtpConfig.emails.split(",");
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let showError = false;
      smptValidation.forEach((mail) => {
        mail = mail.replace(" ", "");
        if (!re.test(mail)) {
          showError = true;
        }
      });

      if (showError) {
        snackbar.show({
          message: "Bitte überprüfen Sie die eingetragenen E-Mail Adressen!",
        });
        return;
      }
    }

    const that = this;
    const xhr = Network.openXHR(
      "POST",
      `${API_PATH}automaticExport/${this.json.data.id}/smtpConfig`
    );
    xhr.onerror = () => {
      snackbar.show({
        message:
          "Beim Speichern der E-Mail Einstellungen ist ein Fehler aufgetreten.",
      });
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        that.toggleModal();
        snackbar.show({
          message: "Die E-Mail Einstellungen wurden erfolgreich gespeichert.",
        });
      }
    };

    xhr.send(JSON.stringify(smtpConfig));
  };
}
